export default "__VITE_ASSET__f0987060__"